import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M9 0a9 9 0 100 18A9 9 0 009 0zm-.83 4.83l-.63-.64-1.28 1.27.64.64L9.8 9l-2.9 2.9-.64.64 1.28 1.27.63-.64 3.54-3.53.63-.64-.63-.64-3.54-3.53z" fill="#EBF4FF" /></svg>);